import { Editor } from '@ckeditor/ckeditor5-core/src/editor/editor';
import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import { AIFillAppAPI } from 'api/ai-fill';
import { AiFillAppDestination } from 'api/ai-fill/types';
import { RichTextEditor } from 'components/atoms/rich-text-editor';
import { AiFillPlaceholderSkeleton } from './ai-fill-placeholder';

const Wrapper = styled.div`
  .editor {
    width: 100%;
    --rte-background: transparent;
    --rte-readonly-content-padding: 0;
    --rte-max-height: unset;
    max-height: unset;
    .ck.ck-content {
      max-height: unset;
    }
  }
`;

interface Props {
  appId: string;
  sourceMeetingIds: number[];
  uniqueId: string;
  editor: Editor;
  destination: AiFillAppDestination;
}
export const AIFillResolveApp: FC<Props> = ({
  appId,
  uniqueId,
  sourceMeetingIds,
  editor,
  destination,
}) => {
  const [data, setData] = useState<string>('');
  const [initialDataLoading, setInitialDataLoadingState] = useState(true);

  useEffect(() => {
    setInitialDataLoadingState(true);
    const api = Number.isNaN(Number(appId))
      ? AIFillAppAPI.streamContentForDefaultAIFillApp
      : AIFillAppAPI.streamContentForCustomAIFillApp;

    api({
      appId,
      sources: sourceMeetingIds.map((sourceId) => ({
        sourceId,
        sourceType: 'MEETING',
      })),
      destination,
      onContentReceived: (content) => {
        // setInitialDataLoadingState(false); // TODO: @kadhirr: removing this for now and setting the state on promise.then() as
        // it was causing the empty placeholder to flash before the editor is loader.
        setData(content);
      },
    }).then((content) => {
      setData(content);
      setInitialDataLoadingState(false);
      editor.execute('ai-fill-resolved', {
        appId,
        uniqueId,
        content,
      });
    });
  }, [appId, destination, editor, sourceMeetingIds, uniqueId]);

  return (
    <Wrapper>
      {initialDataLoading ? (
        <AiFillPlaceholderSkeleton />
      ) : (
        <RichTextEditor className="editor" data={data} readonly />
      )}
    </Wrapper>
  );
};
